import { Col, Input, Row, Select, Table, Button } from "antd";
import { Field, Form, Formik } from "formik";
import React, { FC, useEffect, useRef, useState } from "react";
import ButtonComponent from "../../../shared/components/ButtonComponent";

import { deserialize } from "serializr";
import CommonService from "../../../services/CommonService/common.service";
import ActivityReportsService from "../../../services/ReportsService/ActivityReports.service";

import { MetaModel } from "../../../models/CourseModels/SubjectModel/subject.model";
import { FilterLeaderboard } from "../../../models/LeaderboardModel/Leaderboard.model";
import { ActivitySummaryModel } from "../../../models/ReportsModel/activity.model";
import { PaginationModel } from "../../../models/PaginationModel/pagination.model";
import SubmissionDetails from "./ActivitySubmissionDetails";


interface ActivityReportProps {
  institutes: MetaModel[];
  user: any
}

const ActivityReport: FC<ActivityReportProps> = (props) => {
  const { institutes, user } = props;

  const [initialValues, setInitialValues] = useState<FilterLeaderboard>({
    type: "institute",
  });
  const [branches, setBranches] = useState<MetaModel[]>([]);
  const [boards, setBoards] = useState<MetaModel[]>([]);
  const [branchClassRooms, setBranchClassRooms] = useState<MetaModel[]>([]);
  const [sections, setSections] = useState<MetaModel[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [sectionSubjects, setSectionSubjects] = useState<MetaModel[]>([]);
  const [paginationMeta, setPaginationMeta] = useState<PaginationModel>({});
  const [currentPageNumber, setCurrentPageNumber] = useState<number>(1);
  const [activitySummaryData, setActivitySummaryData] = useState<ActivitySummaryModel[]>([]);
  const [query, setQuery] = useState<FilterLeaderboard>({});


  const [currentActivity, setCurrentActivity] = useState<any>("");
  const [showDetails, setShowDetails] = useState<boolean>(false);

  const formRef = useRef<any>();


  useEffect(() => {
    if (institutes.length && user?.roleName === "instituteadmin") {
      let currentInstituteID = Number(institutes[0].value)
      setInitialValues({ ...initialValues, instituteId: currentInstituteID })
      fetchBranches(currentInstituteID)
    }
  }, [institutes])

  const handleSubmit = (values: FilterLeaderboard) => {
    setQuery(values);
    setCurrentPageNumber(1)
    if (values.type === 'institute' && values.boardId && values.branchId) {
      fetchActivityReportByInst(values)
    } else if (values.type === 'onboard' && values.boardId) {
      fetchLearderboardByOnboard(values)
    }
  };

  const fetchActivityReportByInst = (values: FilterLeaderboard) => {
    setLoading(true)
    ActivityReportsService.fetchActivityReportByInst(
      values,
      (data) => {
        setActivitySummaryData(data);
      },
      () => { },
      () => { setLoading(false) }
    );
  }

  const fetchLearderboardByOnboard = (values: FilterLeaderboard) => {
    setLoading(true)
    ActivityReportsService.fetchActivityReportByInst(
      values,
      (data) => {
        setActivitySummaryData(data);
      },
      () => { },
      () => { setLoading(false) }
    );
  }

  // Download Report
  const handleDownload = (values: FilterLeaderboard) => {
    setLoading(true)
    ActivityReportsService.downloadActivitySummary(
      values,
      (contents) => { },
      () => { },
      () => { setLoading(false) }
    );
  }

  const fetchBranches = (id: number) => {
    CommonService.fetchBranchesMeta(
      id,
      (data) => {
        const response = deserialize(MetaModel, data) as MetaModel[];
        setBranches(response);
      },
      () => { },
      () => { }
    );
  };

  const fetchBoards = () => {
    CommonService.fetchBoardsMeta(
      (data) => {
        const response = deserialize(MetaModel, data) as MetaModel[];
        setBoards(response);
      },
      () => { },
      () => { }
    );
  };

  const fetchSections = (branchId: number, classId: number) => {
    CommonService.fetchSectionsMeta(
      { ClassId: classId, BranchId: branchId },
      (data) => {
        const response = deserialize(MetaModel, data) as MetaModel[];
        setSections(response);
      },
      () => { },
      () => { }
    );
  };

  const fetchSectionSubjects = (id: number) => {
    CommonService.fetchSubjectsMeta(
      id,
      (data) => {
        const response = deserialize(MetaModel, data);
        setSectionSubjects(response);
      },
      () => { },
      () => { }
    );
  };

  const fetchBranchClassRooms = (branchId: number) => {
    CommonService.fetchGradeMeta(
      branchId,
      (data) => {
        const meta = deserialize(MetaModel, data) as MetaModel[];
        setBranchClassRooms(meta);
      },
      () => { },
      () => { }
    );
  };


  useEffect(() => {
    fetchBoards();
  }, []);

  const clearForm = () => {
    user?.roleName === "admin" && setBranches([])
    setSections([])
    setSectionSubjects([])
    setBranchClassRooms([])
    setActivitySummaryData([]);
    setQuery({});
    setLoading(false);
  }




  return (
    <div className="classroom-reports">
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize
        innerRef={formRef}
      >
        {({ setFieldValue, values, resetForm, dirty }) => {
          return (
            <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <div className="institute-reports-filters__container">
                <Row
                  className="classroom-reports-filters__wrapper"
                  gutter={24}
                >
                  <Col span={18}>
                    <Row gutter={[24, 24]}>
                      <Col span={8}>
                        <div className="institute-reports-filter-field__container">
                          <div className="institute-reports-filter-field__label">
                            Filter by
                          </div>
                          <Field
                            disabled={user?.roleName === "instituteadmin" ? true : false}
                            as={Select}
                            name="type"
                            options={[
                              {
                                value: "institute",
                                label: "Institute",
                              },
                              {
                                value: "onboard",
                                label: "Self onboarded",
                              },
                            ]}
                            value={values?.type}
                            placeholder="Select Filter"
                            onChange={(value) => {
                              resetForm()
                              setFieldValue("type", value)
                            }}
                          ></Field>
                        </div>
                      </Col>
                      {values?.type == "institute" && (
                        <>
                          <Col span={8}>
                            <div className="institute-reports-filter-field__container">
                              <div className="institute-reports-filter-field__label">
                                Institute
                              </div>
                              <Field
                                disabled={user?.roleName === "instituteadmin" ? true : false}
                                as={Select}
                                name="instituteId"
                                value={values?.instituteId}
                                options={institutes}
                                placeholder="Select Institute"
                                onChange={(value) => {
                                  resetForm()
                                  setFieldValue("instituteId", value);
                                  value && fetchBranches(value);
                                }}
                              ></Field>
                            </div>
                          </Col>
                          <Col span={8}>
                            <div className="institute-reports-filter-field__container">
                              <div className="institute-reports-filter-field__label">
                                Branch
                              </div>
                              <Field
                                as={Select}
                                options={branches}
                                name="branchId"
                                value={values?.branchId}
                                placeholder="Select Branch"
                                onChange={(value) => {
                                  setFieldValue("branchId", value);
                                  setFieldValue("branchClassRoomId", null);
                                  setFieldValue("sectionId", null);
                                  setFieldValue("sectionSubjectId", null);
                                  fetchBranchClassRooms(value);
                                }}
                              ></Field>
                            </div>
                          </Col>
                        </>
                      )}

                      <Col span={8}>
                        <div className="institute-reports-filter-field__container">
                          <div className="institute-reports-filter-field__label">
                            Board
                          </div>
                          <Field
                            as={Select}
                            name="boardId"
                            options={boards}
                            value={values?.boardId}
                            placeholder="Select Board"
                            onChange={(value) =>
                              setFieldValue("boardId", value)
                            }
                          ></Field>
                        </div>
                      </Col>
                      <Col span={8}>
                        <div className="institute-reports-filter-field__container">
                          <div className="institute-reports-filter-field__label">
                            Class
                          </div>
                          <Field
                            as={Select}
                            name="branchClassRoomId"
                            options={branchClassRooms}
                            value={values?.branchClassRoomId}
                            placeholder="Select Class"
                            onChange={(value) => {
                              setFieldValue("branchClassRoomId", value);
                              setFieldValue("sectionId", null);
                              setFieldValue("sectionSubjectId", null);
                              fetchSectionSubjects(value);
                              values?.branchId &&
                                fetchSections(values?.branchId, value);
                            }}
                          ></Field>
                        </div>
                      </Col>
                      {values?.type == "institute" && (
                        <Col span={8}>
                          <div className="institute-reports-filter-field__container">
                            <div className="institute-reports-filter-field__label">
                              Section
                            </div>
                            <Field
                              as={Select}
                              name="sectionId"
                              options={sections}
                              value={values?.sectionId}
                              placeholder="Select Section"
                              onChange={(value) => {
                                setFieldValue("sectionId", value);
                              }}
                            ></Field>
                          </div>
                        </Col>
                      )}
                      {values?.type == "onboard" && (
                        <Col span={8}>
                          <div className="institute-reports-filter-field__container">
                            <div className="institute-reports-filter-field__label">
                              Subject
                            </div>
                            <Field
                              as={Select}
                              options={sectionSubjects}
                              name="sectionSubjectId"
                              value={values?.sectionSubjectId}
                              placeholder="Select Subject"
                              onChange={(value) =>
                                setFieldValue("sectionSubjectId", value)
                              }
                            ></Field>
                          </div>
                        </Col>
                      )}
                    </Row>
                  </Col>
                  <Col span={6}>
                    <Row gutter={[24, 20]}>
                      <Col span={24}>
                        <div className="institute-reports-filter-btn__wrapper">
                          <ButtonComponent
                            type="text"
                            buttonContent={"Clear Filters"}
                            onClick={() => {
                              resetForm();
                              clearForm()
                            }}
                          />
                          <ButtonComponent
                            type="primary"
                            loading={loading}
                            buttonContent={"Apply Filters"}
                            onClick={() => handleSubmit(values)}
                          />
                        </div>
                      </Col>
                      {values?.type == "institute" && (
                        <Col span={24}>
                          <div className="institute-reports-filter-field__container">
                            <div className="institute-reports-filter-field__label">
                              Subject
                            </div>
                            <Field
                              as={Select}
                              name="sectionSubjectId"
                              options={sectionSubjects}
                              value={values?.sectionSubjectId}
                              placeholder="Select Subject"
                              onChange={(value) =>
                                setFieldValue("sectionSubjectId", value)
                              }
                            ></Field>
                          </div>
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Row>
              </div>
              <div className="institute-reports-search__container">
                {/* <Input
                  placeholder="Search by any branch, class, section ..."
                  prefix={<SearchOutlined />}
                  disabled={query ? false : true}
                  onChange={(e) => {
                    handleSubmit({ ...query, search: e.target.value });
                  }}
                /> */}
                <div></div>
                {activitySummaryData?.length ? (
                  <div>
                    <ButtonComponent
                      type="primary"
                      buttonContent={"Download Report"}
                      onClick={() => handleDownload(values)} />
                  </div>
                ) : (
                  ""
                )}
              </div>
            </Form>
          );
        }}
      </Formik>
      <Table
        columns={[
          {
            title: 'Name',
            dataIndex: 'activityName',
            key: 'name',
            render: (text, row) => <div>
              <strong>{row['activityName']}</strong>
              <br></br>
              <span>{row['teacherName']}</span>
            </div>,

          },
          {
            title: 'Class',
            dataIndex: 'className',
            key: 'className',
          },
          {
            title: 'Section',
            dataIndex: 'sectionName',
            key: 'sectionName',
          },
          {
            title: 'Subject',
            dataIndex: 'subjectName',
            key: 'subjectName',
          },
          {
            title: 'Max Points',
            dataIndex: 'maxPoints',
            key: 'maxPoints',
          },

          {
            title: 'Assigned Count',
            dataIndex: 'assignedCount',
            key: 'assignedCount',
          },
          {
            title: 'TurnIn Count',
            dataIndex: 'turnInCount',
            key: 'turnInCount',
          },
          {
            title: 'Reviewed Count',
            dataIndex: 'reviewedCount',
            key: 'reviewedCount',
          },
          {
            title: "action",
            dataIndex: "",
            key: "action",
            render: (text: string, record: any) => (
              <Button
                onClick={(event) => {
                  event.stopPropagation();
                  setCurrentActivity(record);
                  setShowDetails(true);
                }}
              >
                View Details
              </Button>
            ),
          },

        ]}
        pagination={{ defaultPageSize: 10 }}
        dataSource={activitySummaryData}
        loading={loading}
      />
      <SubmissionDetails
        visible={showDetails}
        setVisible={setShowDetails}
        content={currentActivity}
        setCurrentContent={setCurrentActivity}
      />
    </div>
  );
};

export default ActivityReport;
